import React from 'react';
import Layout from '../../layout';






function Homepage() {
  return (
   <Layout>
      <div id="main-slider" class="main-slider">
            <div class="single-slide">
                <div class="bg-img kenburns-top" style={{backgroundImage: "url(https://res.cloudinary.com/dedfrilse/image/upload/v1700576542/derma/gkx4tfxaht5s8qghnvm1.png)"}}></div>
                <div class="slider-content-wrap d-flex align-items-center">
                    <div class="container">
                        <div class="slider-content">
                            <div class="slider-caption medium"><div class="inner-layer"><div data-animation="fade-in-top" data-delay="0.5s">Great Experience in Building.</div></div></div>
                            <div class="slider-caption big"><div class="inner-layer"><div data-animation="reveal-text" data-delay="1s">Delivering Unique And</div></div>
                            </div>
                            <div class="slider-caption big"><div class="inner-layer"><div data-animation="reveal-text" data-delay="1.5s">Extraordinary Solutions!</div></div></div>
                            <div class="slider-caption small"><div class="inner-layer"><div data-animation="fade-in-bottom" data-delay="2s">We produce positive results from ever-growing Industrial &amp; manufacturing estates, <br/>Have established a corporate mandate to maintain.</div></div></div>
                            <div class="slider-btn-group justify-content-left">
                                <div class="inner-layer">
                                    <a href="/" class="slider-btn" data-animation="fade-in-bottom" data-delay="2.5s">Explore More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="single-slide">
                <div class="bg-img kenburns-top" style={{backgroundImage: "url(https://res.cloudinary.com/dedfrilse/image/upload/v1700576542/derma/orzdnhfoarzquob2tut5.png)"}}></div>
                <div class="slider-content-wrap d-flex align-items-center">
                    <div class="container">
                        <div class="slider-content">
                            <div class="slider-caption medium"><div class="inner-layer"><div data-animation="fade-in-top" data-delay="0.5s">Great Experience in Building.</div></div></div>
                            <div class="slider-caption big"><div class="inner-layer"><div data-animation="reveal-text" data-delay="1s">We Are Professional For</div></div>
                            </div>
                            <div class="slider-caption big"><div class="inner-layer"><div data-animation="reveal-text" data-delay="1.5s">Industrial Solutions!</div></div></div>
                            <div class="slider-caption small"><div class="inner-layer"><div data-animation="fade-in-bottom" data-delay="2s">We produce positive results from ever-growing Industrial &amp; manufacturing estates, <br/>Have established a corporate mandate to maintain.</div></div></div>
                            <div class="slider-btn-group justify-content-left">
                                <div class="inner-layer">
                                    <a href="about.html" class="slider-btn" data-animation="fade-in-bottom" data-delay="2.5s">Explore More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="single-slide">
                <div class="bg-img kenburns-top" style={{backgroundImage: "url(https://res.cloudinary.com/dedfrilse/image/upload/v1700576542/derma/sztbqvwus9bukwulhsos.png)"}}></div>
                <div class="slider-content-wrap d-flex align-items-center">
                    <div class="container">
                        <div class="slider-content">
                            <div class="slider-caption medium"><div class="inner-layer"><div data-animation="fade-in-top" data-delay="0.5s">Great Experience in Building.</div></div></div>
                            <div class="slider-caption big"><div class="inner-layer"><div data-animation="reveal-text" data-delay="1s">Committed To Superior</div></div>
                            </div>
                            <div class="slider-caption big"><div class="inner-layer"><div data-animation="reveal-text" data-delay="1.5s">Quality And Results!</div></div></div>
                            <div class="slider-caption small"><div class="inner-layer"><div data-animation="fade-in-bottom" data-delay="2s">We produce positive results from ever-growing Industrial &amp; manufacturing estates, <br/>Have established a corporate mandate to maintain.</div></div></div>
                            <div class="slider-btn-group justify-content-left">
                                <div class="inner-layer">
                                    <a href="about.html" class="slider-btn" data-animation="fade-in-bottom" data-delay="2.5s">Explore More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       {/* <section class="hero-section padding">
           <div class="bg-shape"></div>
            <div class="container">
                <div class="hero-content">
                    <h4>Great experiance in building</h4>
                    <h2>Building Everything Best <br/>That You <span>Needed!</span></h2>
                    <p>We produce positive results from ever-growing Industrial &amp; manufacturing, <br/>we have established a corporate mandate to maintain.</p>
                    <a href="about.html" class="default-btn">More about us</a>
                </div>
            </div>
        </section> */}
        <section class="about-section padding bd-bottom">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6 sm-padding wow fadeInLeft" data-wow-delay="200ms">
                        <div class="section-heading mb-30">
                            <h2>We're Building Everything Best <br/>That You Needed!</h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                        </div>
                        <div class="row d-flex align-items-center">
                            <div class="col-md-6">
                                <div class="about-list">
                                    <div class="about-icon">
                                        <i class="dl dl-levels"></i>
                                    </div>
                                    <div class="about-content">
                                        <h3>Industrus Mission</h3>
                                        <p>Construction is a general term meaning the art and science to form objects systems.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="about-list">
                                    <div class="about-icon">
                                        <i class="dl dl-industrial-robot-8"></i>
                                    </div>
                                    <div class="about-content">
                                        <h3>Our Vision</h3>
                                        <p>Construction is a general term meaning the art and science to form objects systems.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sign">
                            <a href="about.html" class="default-btn">More about us <span></span></a>
                            {/* <img src="assets/img/sign.png" alt="sign"/> */}
                        </div>
                    </div>
                    <div class="col-md-6 sm-padding wow fadeInRight" data-wow-delay="200ms">
                        <div class="about-img">
                            <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700073980/derma/icg06nimd9x78jrnxbsy.png" alt=""/>
                            <div class="exp-box">
                                <h3>25 Years Of <br/>Experience</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <section class="service-section service-3 padding bd-bottom bg-grey">
            <div class="container">
               <div class="section-heading mb-40 text-center wow fadeInUp" data-wow-delay="200ms">
                    <h4 class="sub-heading">Our Service</h4>
                    <h2>High Quality Construction Solutions <br/>For Residentials &amp; Industries!</h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 sm-padding wow fadeInUp" data-wow-delay="200ms">
                        <div class="service-wrap">
                        <svg
      className="shape"
      fill="#FFEFC5"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100px"
      height="80px"
    >
      <path d="M95.798,66.493 C95.402,67.238 94.989,67.934 94.568,68.608 C92.140,72.492 89.322,75.200 86.228,76.996 C75.718,83.098 62.044,78.694 49.794,74.183 C30.107,66.931 13.369,52.019 4.629,32.917 C0.428,23.737 -1.365,11.491 6.138,4.714 C11.356,0.001 19.072,-0.185 26.172,0.068 C26.493,0.079 26.814,0.090 27.132,0.103 C31.363,0.275 35.595,0.448 39.826,0.620 C45.043,0.833 50.261,1.045 55.479,1.256 C57.205,1.327 58.931,1.397 60.658,1.467 C67.392,1.740 74.374,2.077 80.361,5.160 C89.583,9.908 94.528,20.156 97.310,30.121 C97.438,30.578 97.561,31.039 97.682,31.500 C100.721,43.123 101.423,55.927 95.798,66.493 Z"></path>
    </svg>
                            <i class="dl dl-factory-1"></i>
                            <h3>Derm Electricity</h3>
                            <p>We produce positive results from growing Industrial estates, we have established a corporate or mandate to maintain the manufacturing economy</p>
                            <a href="service.html" class="read-more">Read More</a>
                            <div class="overlay-icon">
                                <i class="dl dl-factory-1"></i>
                            </div>
                            <div class="promo-count">01</div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 sm-padding wow fadeInUp" data-wow-delay="300ms">
                        <div class="service-wrap">
                        <svg
      className="shape"
      fill="#FFEFC5"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="105px"
      height="80px"
    >
      <path d="M104.768,46.596 C103.512,53.499 97.269,58.301 91.117,61.679 C77.841,68.967 63.002,72.833 48.310,76.516 C40.421,78.492 32.367,80.451 24.252,79.893 C23.977,79.874 23.702,79.851 23.426,79.826 C15.577,79.094 7.660,75.615 3.385,69.025 C0.518,64.605 -0.391,59.254 0.154,53.978 C0.481,50.815 1.330,47.677 2.594,44.784 C4.373,40.709 6.870,37.034 9.730,33.620 C12.289,30.568 15.138,27.725 18.038,25.002 C24.140,19.273 30.567,13.891 37.279,8.890 C41.647,5.637 46.299,2.342 51.494,0.551 C56.951,-1.331 61.008,1.926 65.771,4.608 C72.267,8.264 78.490,12.408 84.374,16.984 C86.832,18.895 89.229,20.884 91.564,22.945 C92.385,23.670 93.201,24.402 94.006,25.145 C96.362,27.319 98.710,29.770 100.630,32.428 C103.718,36.705 105.691,41.522 104.768,46.596 Z"></path>
    </svg>
                            <i class="dl dl-industrial-robot-13"></i>
                            <h3>Derm Elevators</h3>
                            <p>We produce positive results from growing Industrial estates, we have established a corporate or mandate to maintain the manufacturing economy</p>
                            <a href="service.html" class="read-more">Read More</a>
                            <div class="overlay-icon">
                                <i class="dl dl-industrial-robot-13"></i>
                            </div>
                            <div class="promo-count">02</div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 sm-padding wow fadeInUp" data-wow-delay="400ms">
                        <div class="service-wrap">
                        <svg
      className="shape"
      fill="#FFEFC5"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="119px"
      height="80px"
    >
      <path d="M118.988,32.868 C118.954,33.798 118.867,34.713 118.740,35.616 C117.289,45.963 109.998,54.513 102.246,60.696 C100.672,61.950 99.062,63.147 97.419,64.283 C85.885,72.259 72.742,77.274 59.279,78.981 C53.104,79.765 44.685,81.169 38.854,78.104 C32.784,74.915 27.054,69.136 21.255,65.231 C15.037,61.044 8.845,56.391 4.621,49.782 C0.397,43.173 -1.534,34.183 1.434,26.764 C2.652,23.719 4.595,21.166 6.927,19.084 C9.080,17.161 11.562,15.641 14.122,14.520 C16.812,13.341 19.604,12.537 22.432,11.873 C25.211,11.221 28.024,10.704 30.810,10.101 C32.737,9.685 34.655,9.223 36.569,8.737 C45.702,6.418 54.720,3.489 63.942,1.669 C75.098,-0.533 86.824,-1.043 97.533,3.095 C103.301,5.324 108.727,8.943 112.734,14.101 C114.004,15.737 115.121,17.535 116.049,19.444 C118.047,23.560 119.159,28.199 118.988,32.868 Z"></path>
    </svg>
                            <i class="dl dl-industrial-robot-18"></i>
                            <h3>Skyline Properties</h3>
                            <p>We produce positive results from growing Industrial estates, we have established a corporate or mandate to maintain the manufacturing economy</p>
                            <a href="service.html" class="read-more">Read More</a>
                            <div class="overlay-icon">
                                <i class="dl dl-industrial-robot-18"></i>
                            </div>
                            <div class="promo-count">03</div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}
       <div className='bannersection'>
        <img src='https://res.cloudinary.com/dedfrilse/image/upload/v1700491988/derma/mcnt0idiawqhiblay2mo.jpg' />
       </div>
        <section class="project-section bd-bottom">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6">
                        <div class="section-heading mb-40">
                            {/* <h4>Our Project</h4> */}
                            <h2>Transforming The Ideas And <br/>Visions For Industries!</h2>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="section-heading mb-40">
                            <p>Construction is a general term meaning the art and science to form <br/>objects systems organizations.</p>
                            <a href="project-4-col.html" class="default-btn">View our companies <span></span></a>
                        </div>
                    </div>
                </div>
                <div class="slider project-carousel nav-style dl-lb-gallery">
                    <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700581639/derma/b2oqfaap2yzd1dtdyth4.png" alt="project"/>
                            <div class="project-view">
                                <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700581639/derma/b2oqfaap2yzd1dtdyth4.png"><i class="fas fa-plus"></i></a>
                            </div>
                        </div>
                        <div class="project-content">
                            <h3><a href="project-4-col.html">Derm Group</a></h3>
                            <a href="project-4-col.html" class="cat">Learn more</a>
                        </div>
                    </div>
                    <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700581629/derma/ws9scb1i7p8dkzda7d9u.png" alt="project"/>
                           <div class="project-view">
                                <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700581629/derma/ws9scb1i7p8dkzda7d9u.png"><i class="fas fa-plus"></i></a>
                           </div>
                        </div>
                        <div class="project-content">
                            <h3><a href="project-4-col.html">Derm Elevators</a></h3>
                            <a href="project-4-col.html" class="cat">Learn more</a>
                        </div>
                    </div>
                    <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700581629/derma/yaj7tmaqvpzs97lym8cq.png" alt="project"/>
                            <div class="project-view">
                            <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700581629/derma/yaj7tmaqvpzs97lym8cq.png"><i class="fas fa-plus"></i></a>
                            </div>
                        </div>
                        <div class="project-content">
                            <h3><a href="project-4-col.html"> Coast Concrete Poles</a></h3>
                            <a href="project-4-col.html" class="cat">Learn more</a>
                        </div>
                    </div>
                    <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700581651/derma/aou5eql1awxcdftidy9m.png" alt="project"/>
                               <div class="project-view">
                                <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700581651/derma/aou5eql1awxcdftidy9m.png"><i class="fas fa-plus"></i></a>
                            </div>
                        </div>
                        <div class="project-content">
                            <h3><a href="project-4-col.html">Skyline Properties</a></h3>
                            <a href="project-4-col.html" class="cat">Learn more</a>
                        </div>
                    </div>
                    {/* <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700075885/derma/vyazyggnmftsgqabjjbc.png" alt="project"/>
                            <div class="project-view">
                                <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700075885/derma/vyazyggnmftsgqabjjbc.png"><i class="fas fa-plus"></i></a>
                            </div>
                        </div>
                        <div class="project-content">
                            <a href="project-4-col.html" class="cat">Realstate</a>
                            <h3><a href="project-4-col.html">Vincom Landmark 81</a></h3>
                        </div>
                    </div> */}
                </div>
             </div>
            <div class="counter-wrapper padding">
               <div class="bg-pattern"></div>
                <div class="container">
                    <div class="row d-flex align-items-center mt-50">
                    <div class="col-lg-4 wow fadeInUp" data-wow-delay="200ms">
                        <div class="section-heading light">
                            <h4>Some Facts</h4>
                            <h2>Delivering The Most<br/> Innovation Goals!</h2>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 sm-padding wow fadeInUp" data-wow-delay="300ms">
                        <div class="counter-item">
                            <div class="counter-content">
                                <h3><span class="odometer" data-count="3,245">00</span></h3>
                                <h4>Projects Complete</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 sm-padding wow fadeInUp" data-wow-delay="400ms">
                        <div class="counter-item">
                            <div class="counter-content">
                                <h3><span class="odometer" data-count="2,518">00</span></h3>
                                <h4>Happy Customer</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 sm-padding wow fadeInUp" data-wow-delay="500ms">
                        <div class="counter-item">
                            <div class="counter-content">
                                <h3><span class="odometer" data-count="6274">00</span></h3>
                                <h4>Hours Worked</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 sm-padding wow fadeInUp" data-wow-delay="600ms">
                        <div class="counter-item">
                            <div class="counter-content">
                                <h3><span class="odometer" data-count="3245">00</span></h3>
                                <h4>Worldwide Brunch</h4>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <section class="project-section padding">
            <div class="container">
              <div class="section-heading mb-40 text-center wow fadeInUp" data-wow-delay="200ms">
                    {/* <h4 class="sub-heading">Our Project</h4> */}
                    <h2>Transforming The Ideas <br/>And Visions For <span>Industries!</span></h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
               <div class="row">
                   <div class="col-lg-12">
                       <ul class="project-filter text-center">
                            <li class="active electrical" data-filter=".electrical">ELECTRICAL</li>
                            <li data-filter=".architecture ">ICT SYSTEMS</li>
                            <li data-filter=".building">ELEVATORS</li>
                            <li data-filter=".construction">PROPERTIES</li>
                            {/* <li data-filter=".industrial">Industrial</li> */}
                        </ul>
                   </div>
               </div>
                <div class="project-items dl-lb-gallery row">
                <div class="col-lg-4 col-md-6 padding-15 single-item electrical">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407677/derma/oq1jig5io3fivijlxsgo.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407677/derma/oq1jig5io3fivijlxsgo.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Architecture</a>
                                <h3><a href="project-details.html">The Burj Khalifa</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item electrical building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407749/derma/r6oizgokvgbmn3cdx7md.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407749/derma/r6oizgokvgbmn3cdx7md.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Construction</a>
                                <h3><a href="project-details.html">Shun Hing Square</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item electrical">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407748/derma/eeapzgvyrotekynsss9w.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407748/derma/eeapzgvyrotekynsss9w.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Building</a>
                                <h3><a href="project-details.html">World Trade Center</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item architecture building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407748/derma/vwdlgmul0snkcizrqlyh.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407748/derma/vwdlgmul0snkcizrqlyh.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Architecture</a>
                                <h3><a href="project-details.html">The Burj Khalifa</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item construction building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407747/derma/f2vicb4eyfuzn6oofisj.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407747/derma/f2vicb4eyfuzn6oofisj.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Construction</a>
                                <h3><a href="project-details.html">Shun Hing Square</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item construction architecture">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407747/derma/i1bovagymy7dkaf5v9os.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407747/derma/i1bovagymy7dkaf5v9os.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Building</a>
                                <h3><a href="project-details.html">World Trade Center</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item architecture">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407747/derma/nirfiar6nenr3zhdeykv.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407747/derma/nirfiar6nenr3zhdeykv.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Industries</a>
                                <h3><a href="project-details.html">Mercury City Tower</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item construction industrial">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407677/derma/oq1jig5io3fivijlxsgo.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407677/derma/oq1jig5io3fivijlxsgo.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Building</a>
                                <h3><a href="project-details.html">Central Park Tower</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item industrial">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407748/derma/eeapzgvyrotekynsss9w.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700407748/derma/eeapzgvyrotekynsss9w.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="project-4-col.html" class="cat">Construction</a>
                                <h3><a href="project-details.html">Vincom Landmark 81</a></h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="blog-section bd-bottom padding" style={{backgroundColor: '#eeeeee'}}>
            <div class="container">
               <div class="section-heading mb-40 text-center wow fadeInUp" data-wow-delay="200ms">
                    {/* <h4 class="sub-heading" style={{color: '#3F3C3A'}}>From Blog</h4> */}
                    <h2>Our Latest <span>News & Events </span></h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
                <div class="blog-wrap row">
                    <div class="col-lg-4 col-md-6 padding-15 wow fadeInUp" data-wow-delay="200ms">
                        <div class="blog-item">
                            <div class="blog-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700075565/derma/rwhc2smeszhwtdwgkdbx.png" alt="post"/>
                                <span class="category"><a href="blog-grid.html">interior</a></span>
                            </div>
                            <div class="blog-content">
                                <h3><a href="blog-details.html">Industrial Factory Building Equipment 2021</a></h3>
                                <p>The new functions coming to construction for equipment mathematics promise make life easier for owners...</p>
                                <a href="blog-details.html" class="read-more">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 wow fadeInUp" data-wow-delay="300ms">
                        <div class="blog-item">
                            <div class="blog-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700075565/derma/kmerybkfdon9iz79t9yp.png" alt="post"/>
                                <span class="category"><a href="blog-grid.html">Architecture</a></span>
                            </div>
                            <div class="blog-content">
                                <h3><a href="blog-details.html">The Evolution Of Construction Services 1995</a></h3>
                                <p>The new functions coming to construction for equipment mathematics promise make life easier for owners...</p>
                                <a href="blog-details.html" class="read-more">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 wow fadeInUp" data-wow-delay="400ms">
                        <div class="blog-item">
                            <div class="blog-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700075565/derma/roj2xtdeo4rtll9kdyvi.png" alt="post"/>
                                <span class="category"><a href="blog-grid.html">Constuction</a></span>
                            </div>
                            <div class="blog-content">
                                <h3><a href="blog-details.html">Manufacturing The Industries Construction INC</a></h3>
                                <p>The new functions coming to construction for equipment mathematics promise make life easier for owners...</p>
                                <a href="blog-details.html" class="read-more">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="sponsor-section">
            <div class="container">
                <div class="slider sponsor-carousel nav-style">
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-6.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-3.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                </div>
            </div>
        </div>
   </Layout>
  );
}

export default Homepage;